// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/backgroundremover/v2/service.proto (package creativefabrica.backgroundremover.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DeleteAllRequestSchema, DeleteAllResponseSchema, DeleteRequestSchema, DeleteResponseSchema, DownloadProcessRequestSchema, DownloadProcessResponseSchema, DownloadRequestSchema, DownloadResponseSchema, GetDownloadRequestSchema, GetDownloadResponseSchema, GetImagesRequestSchema, GetImagesResponseSchema, GetRequestSchema, GetResponseSchema, InitiateRequestSchema, InitiateResponseSchema, ListRequestSchema, ListResponseSchema, MigrateAnonymousUserRequestSchema, MigrateAnonymousUserResponseSchema, OnProcessingCompletedRequestSchema, OnProcessingCompletedResponseSchema, OnUploadCompletedRequestSchema, OnUploadCompletedResponseSchema, PublishSessionRequestSchema, PublishSessionResponseSchema } from "@repo/rpc-types-creativefabrica-common-v1/imageprocessor/v1";
import { file_creativefabrica_common_v1_imageprocessor_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/imageprocessor/v1";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/backgroundremover/v2/service.proto.
 */
export const file_creativefabrica_backgroundremover_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_imageprocessor_v1_types, file_google_api_annotations]);

/**
 * @generated from message creativefabrica.backgroundremover.v2.GetPricingRequest
 */
export type GetPricingRequest = Message<"creativefabrica.backgroundremover.v2.GetPricingRequest"> & {
  /**
   * Number of images the caller intends to submit, capped at the 100 image
   * session limit. 0 returns the unit price with a zero total.
   *
   * @generated from field: uint32 image_count = 1;
   */
  imageCount: number;
};

/**
 * @generated from message creativefabrica.backgroundremover.v2.GetPricingRequest
 */
export type GetPricingRequestJson = {
  /**
   * Number of images the caller intends to submit, capped at the 100 image
   * session limit. 0 returns the unit price with a zero total.
   *
   * @generated from field: uint32 image_count = 1;
   */
  imageCount?: number;
};

/**
 * Describes the message creativefabrica.backgroundremover.v2.GetPricingRequest.
 * Use `create(GetPricingRequestSchema)` to create a new message.
 */
export const GetPricingRequestSchema: GenMessage<GetPricingRequest, {jsonType: GetPricingRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_backgroundremover_v2_service, 0);

/**
 * @generated from message creativefabrica.backgroundremover.v2.GetPricingResponse
 */
export type GetPricingResponse = Message<"creativefabrica.backgroundremover.v2.GetPricingResponse"> & {
  /**
   * Coins charged per image.
   *
   * @generated from field: int64 unit_amount = 1;
   */
  unitAmount: bigint;

  /**
   * unit_amount multiplied by the requested image_count.
   *
   * @generated from field: int64 total_amount = 2;
   */
  totalAmount: bigint;
};

/**
 * @generated from message creativefabrica.backgroundremover.v2.GetPricingResponse
 */
export type GetPricingResponseJson = {
  /**
   * Coins charged per image.
   *
   * @generated from field: int64 unit_amount = 1;
   */
  unitAmount?: string;

  /**
   * unit_amount multiplied by the requested image_count.
   *
   * @generated from field: int64 total_amount = 2;
   */
  totalAmount?: string;
};

/**
 * Describes the message creativefabrica.backgroundremover.v2.GetPricingResponse.
 * Use `create(GetPricingResponseSchema)` to create a new message.
 */
export const GetPricingResponseSchema: GenMessage<GetPricingResponse, {jsonType: GetPricingResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_backgroundremover_v2_service, 1);

/**
 * @generated from service creativefabrica.backgroundremover.v2.BackgroundRemoverService
 */
export const BackgroundRemoverService: GenService<{
  /**
   * GetPricing quotes what Initiate would charge for a given number of images.
   * Requires no signed-in user, so a price can be shown before sign-in.
   *
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetPricing
   */
  getPricing: {
    methodKind: "unary";
    input: typeof GetPricingRequestSchema;
    output: typeof GetPricingResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Initiate
   */
  initiate: {
    methodKind: "unary";
    input: typeof InitiateRequestSchema;
    output: typeof InitiateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetImages
   */
  getImages: {
    methodKind: "unary";
    input: typeof GetImagesRequestSchema;
    output: typeof GetImagesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Download
   */
  download: {
    methodKind: "unary";
    input: typeof DownloadRequestSchema;
    output: typeof DownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetDownload
   */
  getDownload: {
    methodKind: "unary";
    input: typeof GetDownloadRequestSchema;
    output: typeof GetDownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof DeleteResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.DeleteAll
   */
  deleteAll: {
    methodKind: "unary";
    input: typeof DeleteAllRequestSchema;
    output: typeof DeleteAllResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.PublishSession
   */
  publishSession: {
    methodKind: "unary";
    input: typeof PublishSessionRequestSchema;
    output: typeof PublishSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_backgroundremover_v2_service, 0);

/**
 * @generated from service creativefabrica.backgroundremover.v2.BackgroundRemoverInternalService
 */
export const BackgroundRemoverInternalService: GenService<{
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverInternalService.OnProcessingCompleted
   */
  onProcessingCompleted: {
    methodKind: "unary";
    input: typeof OnProcessingCompletedRequestSchema;
    output: typeof OnProcessingCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverInternalService.DownloadProcess
   */
  downloadProcess: {
    methodKind: "unary";
    input: typeof DownloadProcessRequestSchema;
    output: typeof DownloadProcessResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverInternalService.OnUploadCompleted
   */
  onUploadCompleted: {
    methodKind: "unary";
    input: typeof OnUploadCompletedRequestSchema;
    output: typeof OnUploadCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverInternalService.MigrateAnonymousUser
   */
  migrateAnonymousUser: {
    methodKind: "unary";
    input: typeof MigrateAnonymousUserRequestSchema;
    output: typeof MigrateAnonymousUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_backgroundremover_v2_service, 1);

